<template>
  <div class="ListaOSCanceladas">
    <div class="ListaOSCanceladas_header p-2">
      <div class="row justify-content-between">
        <div class="col-2">
          Número da OS
        </div>
        <div class="col-2">
          Data da OS
        </div>
        <div class="col-4">
          Matrícula do Registro em que estava vinculada
        </div>
        <div class="col-2">
          Tipo do registro
        </div>
        <div class="col-2">
          Data do cancelamento
        </div>
      </div>
    </div>
    <div v-for="(os, index) in propListaOs"
         :key="index"
         class="ListaOSCanceladas_item p-2">
      <div class="row justify-content-between">
        <div class="col-2">
          {{ os.numero }}
        </div>
        <div class="col-2">
          {{ os.created_at | date }}
        </div>
        <div class="col-4">
          <span v-if="os.registro">
            {{ os.registro.matricula | maskMatricula }}
          </span>
        </div>
        <div class="col-2">
          <span v-if="os.registro">
            {{ tiposRegistro[os.registro.tipo_registro] }}
          </span>
        </div>
        <div class="col-2">
          {{ os.data_cancelamento | date }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "ListaOSCanceladas",
    props: {
      propListaOs: { type: Array, default: () =>([])}
    },
    data () {
      return {
        tiposRegistro: {
          'N': 'Nascimento',
          'C': 'Casamento',
          'CR': 'Casamento Religioso',
          'O': 'Óbito',
          'NT': 'Natimorto',
          'D': 'Habilitação'
        }
      }
    }
  }
</script>
<style lang="scss">
  .ListaOSCanceladas {
    &_header {
      background: #01bfa5;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
    }

    &_item {
      font-family: Roboto;
      font-size: 16px;
    }

    &_item:nth-child(even) {
      background: #eaeaea;
    }
    &_item:nth-child(odd) {
      background: #ffffff;
    }
  }

</style>
